import { render, staticRenderFns } from "./StockInventoryTask.vue?vue&type=template&id=f62fc82c&scoped=true&"
import script from "./StockInventoryTask.vue?vue&type=script&lang=js&"
export * from "./StockInventoryTask.vue?vue&type=script&lang=js&"
import style0 from "./StockInventoryTask.vue?vue&type=style&index=0&id=f62fc82c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62fc82c",
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QBtn,QTooltip,QIcon,QCardActions,QSeparator,QCard,QCardSection,QBanner,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QToolbar,QToolbarTitle,QBtn,QTooltip,QIcon,QCardActions,QSeparator,QCard,QCardSection,QBanner,QInnerLoading,QSpinnerGears}, component.options.components || {})
